@let data = section();

<section class="cms-cards-group tg-section">
    <div class="tg-container">
        @if (data.contentGroupContent) {
            <div class="cms-cards-group__intro">
                <div class="cms-content" [innerHTML]="data.contentGroupContent | trustHtml"></div>
            </div>
        }

        <div class="cms-cards-group__steps">
            @for (group of data.groups; track group.id) {
                <article
                    class="cms-cards-group__card"
                    [class.cms-cards-group__card--dark]="isDark(group.backgroundColorHex)"
                >
                    <div>
                        @if (group.title) {
                            <div class="cms-cards-group__caption">{{ group.title }}</div>
                        }
                        @if (group.content) {
                            <div class="cms-content" [innerHTML]="group.content | trustHtml"></div>
                        }
                    </div>
                    @if (group.itemsList.length) {
                        <div class="cms-cards-group__tags">
                            @for (item of group.itemsList; track item.id) {
                                <app-module-chip variant="tag" [label]="item.itemLabel" [image]="item.itemLabelImage" />
                            }
                        </div>
                    }
                </article>
            }
        </div>
    </div>
</section>
